import React, { useState, useRef } from "react";
import emailjs from "@emailjs/browser";

import "./contact-form-component-styles.scss";
import emailjsdata from "./emailjs-data";

import { RiSendPlaneFill } from "react-icons/ri";

const ContactFormComponent = () => {
	const form = useRef();
	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [message, setMessage] = useState("");
	const [submitted, setSubmitted] = useState(false);

	const handleSendEmail = (e) => {
		e.preventDefault();

		emailjs
			.sendForm(
				emailjsdata.service_id,
				emailjsdata.template_id,
				form.current,
				emailjsdata.public_key
			)
			.then(
				// emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, form.current, USER_ID).then(
				(result) => {
					console.log(result.text);
				},
				(error) => {
					console.log(error.text);
				}
			);
		e.target.reset();
		setName("");
		setEmail("");
		setMessage("");
		setSubmitted(true);

		// setTimeout(() => {
		// 	setSubmitted(false);
		// }, 3000);
	};
	return (
		<>
			{submitted ? (
				<div className="success-message">
					<p>
						Thanks for contacting! I will get in touch with you as
						soon as possible.
					</p>
				</div>
			) : (
				<form
					onSubmit={handleSendEmail}
					ref={form}
					className="contact-form"
				>
					<input
						name="user_name"
						value={name}
						className="inputField nameField"
						type="text"
						placeholder="Your Name"
						onChange={(e) => setName(e.target.value)}
						required
					/>
					<input
						name="user_email"
						value={email}
						className="inputField emailField"
						type="email"
						placeholder="Your Email"
						onChange={(e) => setEmail(e.target.value)}
						required
					/>
					<input
						name="user_message"
						value={message}
						className="inputField messageField"
						type="text"
						placeholder="Message..."
						onChange={(e) => setMessage(e.target.value)}
						required
					/>
					<button class="button" type="submit">
						Send Message <RiSendPlaneFill />
					</button>
				</form>
			)}
		</>
	);
};

export default ContactFormComponent;
